export default {
    root: {
        class: ['tw-flex tw-items-stretch tw-w-full'],
    },
};
